import { styled } from "@mui/material";
import { editorToolbarName } from "../classes.js";
const Root = styled("div", {
  name: editorToolbarName,
  slot: "Root",
  overridesResolver: (_props, styles) => [styles.root]
})(({ theme }) => ({
  borderBottom: `1px solid ${(theme.vars ?? theme).palette.divider}`,
  display: "flex",
  alignItems: "center",
  flexDirection: "row"
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
